module.exports = __webpack_public_path__ + "static/media/eg.4259fc9e.svg";